<template>
    <div>
        <!--<div class="tab-header">
            Miete
        </div>-->
        <ul class="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li v-for="(year, index) in this.getYears"
                class="nav-item"
                role="presentation">
                <button class="nav-link"
                    :class="index == 0 ? 'active': ''"
                    :id="getYearButtonId(year)"
                    data-toggle="tab"
                    :data-target="getTarget(year)"
                    type="button"
                    role="tab"
                    :aria-controls="year"
                    :aria-selected="index == 0 ? true : false">{{year}}</button>
            </li>

        </ul>
        <div class="tab-content"
            id="priceTabContent">
            <div v-for="(year, index) in this.getYears"
                class="tab-pane fade"
                :class="index == 0 ? 'show active' : ''"
                :id="getTabId(year)"
                role="tabpanel"
                :aria-labelledby="getTabAreaLabel(year)">
                <table class="table pricelist table-hover">
                    <thead>
                        <tr class="subrow">
                            <th>Saison</th>
                            <th>Zeitraum</th>
                            <th class="text-center">Preis pro Woche *</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody v-for="sg in priceArray">


                        <tr v-if="(sg.service.type == 'RENT' || sg.service.type == 'VTAX') && sg.service.name!='Personenaufschlag'">
                            <td colspan="5"
                                class="tab-header">
                                {{sg.service.name}}
                            </td>
                        </tr>
                        <tr v-for="price in sg.lines"
                            v-if="isDateInRange(price.fromdate, year)"
                            class="subrow">
                            <td class="subinfo">
                                <span>{{price.season}}</span>
                                <br/>
                            </td>
                            <td><span v-if="price.fromdate">{{getFormattedDate(price.fromdate)}} - {{getFormattedDate(price.tilldate)}}</span></td>
                            <td class="text-center">
                                <span v-html="getCalculatedPrice(price.value)"></span>
                                <!--<span v-if="price.calculation == 'NIGHT'"> pro Nacht</span>
                                <span v-if="price.calculation != 'NIGHT'"> pro Woche</span>-->
                            </td>
                            <td>
                                <span v-if="sg.service.type == 'RENT' && sg.nightRange && sg.nightRange.min">
												{{sg.nightRange.min}} Nächte
  										  </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'price-tab',
    	props: {
    		pricelist: String,
    		unitgroup: String
    	},
    	data: function() {
    		return {
    			priceArray: {},
    			unitId: Number,
    			priceBookingFee: Number,
    			priceFinalCleaning: Number
    		};
    	},
    	mounted: function() {
    		//console.log('mounted:::::pricelist::::::::');
    		console.log('mounted:::::unitgroup::::::::' + this.unitgroup);
    		var pricelist = JSON.parse(this.pricelist);
    		var unitgroupval = this.unitgroup;

    		this.priceArray = pricelist;

    		//console.log('Pricelist::', pricelist);
    		var years = [];

    		var i, j;
    		for (i = 0; i < pricelist.length; i++) {
    			if (pricelist[i].service.type && pricelist[i].service.type === 'FINALCLEANING') {
    				console.log('Type::', pricelist[i].service.type, 'Price::', pricelist[i].price);
    				this.priceFinalCleaning = pricelist[i].price;
    			}
    			if (pricelist[i].service.type && pricelist[i].service.type === 'BOOKING_FEE') {
    				console.log('Type::', pricelist[i].service.type, 'Price::', pricelist[i].price);
    				this.priceBookingFee = pricelist[i].price;
    			}
    			for (j = 0; j < pricelist[i].lines.length; j++) {
    				console.log('inside loop date::' + pricelist[i].lines[j].fromdate);
    				if (pricelist[i].lines[j].fromdate) {
    					var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    					//console.log('year is::' + year);
    					if (years.indexOf(year) < 0) {
    						years.push(year);
    					}
    				}
    			}
    		}
    		//	console.log('years::' + years);
    		console.log('this.pricelist::' + this.pricelist);
    	},
    	methods: {
    		priceToEuro: function(value) {
    			//console.log(value);
    			var sum = (parseFloat(value) / 100) * VOFFICE.settings.exchangeRate;
    			//console.log('Summe:', sum);
    			var rounded = Number(sum.toFixed(2));
    			//console.log('rounded:', rounded);
    			var euro = '(ca. ' + rounded.toLocaleString('de-DE', {
    				minimumFractionDigits: 0,
    				maximumFractionDigits: 0
    			}) + ' €)';
    			return euro;
    		},
    		getYearButtonId: function(year) {
    			return 't' + year + '-tab';
    		},
    		getTarget: function(year) {
    			return "#t" + year;
    		},
    		getTabId: function(year) {
    			return "t" + year;
    		},
    		getTabAreaLabel: function(year) {
    			return "t" + year + "-tab";
    		},
    		getFormattedDate: function(date) {
    			return DateEx.formatDate(date, 'dd.MM.yy', 'de');
    		},
    		getCalculatedPrice: function(price) {
    			var rentPrice = 0;
    			var calcPrice = 0;
    			if (price > 0) {
    				//rentPrice = Number((price) + (price) * 0.2);
    				console.log("unitgrup value is==>" + this.unitgroup);
    				if (this.unitgroup == '14624') {
    					console.log("inside 14624");
    					rentPrice = Number((price) * 1.25);
    					// rentPrice = Number((price) + ((price) * 0.2));

    				} else if (this.unitgroup == '14090') {
    					console.log("inside 14090");
    					rentPrice = Number((price) * 1.334);
    					// rentPrice = Number((price) + (price) * 0.25);
    				} else if (this.unitgroup == '14688') {
    					console.log("inside 14688");
    					rentPrice = Number((price) * 1.177);
    					// rentPrice = Number((price) + (price) * 0.15);
    				} else {
    					console.log("inside else");
    					rentPrice = price;
    				}
    				console.log("rentprice calculated==>" + rentPrice);
    				console.log("rent price is==>" + rentPrice);
    				//console.log("price is==>" + Number((rentPrice) + (rentPrice) * 0.2));
    				calcPrice = "SEK " + Number((rentPrice) / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				});
    				calcPrice += '<br/>' + this.priceToEuro(rentPrice);

    			}
    			return calcPrice;
    		},
    		isDateInRange: function(fromdate, year) {
    			if (!fromdate) {
    				return true;
    			}
    			var fromYear = parseInt(fromdate.substring(0, 4));
    			if (fromYear == year) {
    				return true;
    			}
    			return false;
    		}

    	},
    	computed: {
    		getYears: function() {
    			var pricelist = JSON.parse(this.pricelist);

    			//console.log('Pricelist::', pricelist);
    			var years = [];

    			var i, j;
    			for (i = 0; i < pricelist.length; i++) {
    				for (j = 0; j < pricelist[i].lines.length; j++) {
    					if (pricelist[i].lines[j].fromdate) {
    						var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    						if (years.indexOf(year) < 0) {
    							years.push(year);
    						}
    					}
    				}
    			}
    			return years;
    		}
    	}
    };
</script>